import { c as _c } from "react/compiler-runtime";
import type { LinkButtonProps } from '@onefootprint/ui';
import { LinkButton } from '@onefootprint/ui';
import type React from 'react';
export type FieldsetProps = {
  children: React.ReactNode;
  cta?: {
    label: string;
    disabled?: boolean;
    onClick?: () => void;
    type?: LinkButtonProps['type'];
    form?: string;
  };
  title: string;
};
const Fieldset = t0 => {
  const $ = _c(13);
  const {
    children,
    cta,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="text-label-2 text-primary fp-text">{title}</div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== cta) {
    t2 = cta && <LinkButton onClick={cta.onClick} disabled={cta.disabled} type={cta.type} form={cta.form}>{cta.label}</LinkButton>;
    $[2] = cta;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <header className="mb-5 flex items-center justify-between max-md:gap-3">{t1}{t2}</header>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = <div className="flex flex-col gap-4">{children}</div>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== title) {
    t5 = <fieldset aria-label={title} className="[&:not(:last-child)]:border-b [&:not(:last-child)]:border-tertiary [&:not(:last-child)]:mb-6 [&:not(:last-child)]:pb-6">{t3}{t4}</fieldset>;
    $[9] = t3;
    $[10] = t4;
    $[11] = title;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default Fieldset;